import { cn } from '../../lib/cn';
import styles from './Section.module.css';

/**
 * A top-level page band: vertical rhythm plus the centred container.
 * `bleed` opts out of the container so carousels can run full-width.
 */
export function Section({
  as: Tag = 'section',
  id,
  tone,          // 'alt' | 'dark'
  spacing,       // 'tight' | 'flush'
  bleed = false,
  className,
  containerClassName,
  children,
  ...rest
}) {
  return (
    <Tag
      id={id}
      className={cn(styles.section, tone && styles[tone], spacing && styles[spacing], className)}
      {...rest}
    >
      {bleed ? children : <div className={cn('container', containerClassName)}>{children}</div>}
    </Tag>
  );
}
